<button
  class="{{ type }} {{ variant }} {{ size }}"
  [disabled]="disabled"
  [ngClass]="{ hovered: hovered, 'inner-fill': innerFill }"
  (mouseenter)="hovered = !disabled"
  (mouseleave)="hovered = false"
>
  <!-- Custom SVG icon (left position) -->
  <img *ngIf="iconSrc && iconPosition === 'left'" [src]="iconSrc" class="custom-icon" alt="icon" />
  <!-- Phosphor icon (left position) -->
  <i *ngIf="icon && !iconSrc && iconPosition === 'left'" class="{{ iconType }} {{ iconName }}"></i>
  <span>
    <ng-content />
  </span>
  <!-- Custom SVG icon (right position) -->
  <img *ngIf="iconSrc && iconPosition === 'right'" [src]="iconSrc" class="custom-icon" alt="icon" />
  <!-- Phosphor icon (right position) -->
  <i *ngIf="icon && !iconSrc && iconPosition === 'right'" class="{{ iconType }} {{ iconName }}"></i>
</button>
